import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

// Layouts
import RootLayout from "@/layouts/RootLayout";
import AuthLayout from "@/layouts/AuthLayout";
import BookingLayout from "@/layouts/BookingLayout";

// Pages
import HomePage from "@/pages/home";
import AuthScreen from "@/pages/auth";
import BookingPage from "@/pages/booking";
import NotFoundPage from "@/pages/public/NotFoundPage";
import About from "@/pages/public/About";
import HowItWorks from "@/pages/public/HowItWorks";
import Terms from "@/sections/terms";
import PrivacyPolicy from "@/components/common/PrivacyPolicy";
import TermsAndConditions from "@/components/common/TnC";
import Refund from "@/components/common/Refund";
import PaymentSuccess from "@/pages/booking/PaymentSuccess";
import PaymentFailed from "@/pages/booking/PaymentFailed";
import VendorOnboardForm from "@/pages/vendor/VendorOnboardForm";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* Public routes */}
        <Route element={<RootLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/tnc" element={<TermsAndConditions />} />
          <Route path="/refund" element={<Refund />} />
        </Route>

        {/* Auth route */}
        <Route element={<AuthLayout />}>
          <Route path="/auth" element={<AuthScreen />} />
        </Route>

        {/* Booking routes - temporarily without auth */}
        <Route element={<BookingLayout />}>
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
        </Route>

        {/* Vendor routes - standalone without header/footer */}
        <Route path="/onboard-vendor" element={<VendorOnboardForm />} />

        {/* Special routes */}
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
      <Toaster position="top-center" />
    </QueryClientProvider>
  );
}

export default App;
